export default __webpack_public_path__ + "static/media/1Zakat BG.80a662b8.png";